import EmailNotifications from 'views/emailNotifications/EmailNotification.container';

export default EmailNotifications;